<section class="subject-section" aria-labelledby="subjects-title">
  <div class="subject-heading">
    <div>
      <p>FOLLOW YOUR CURIOSITY</p>
      <h2 id="subjects-title">Explore by subject</h2>
    </div>
    <a routerLink="/search"
      >View all resources <span aria-hidden="true">→</span></a
    >
  </div>
  @if (!subjects.length) {
    <p class="suggestion-label">
      Popular starting points — search a topic to discover resources.
    </p>
  }
  <div class="subject-grid">
    @for (subject of visibleSubjects; track subject.id || subject.name) {
      <a
        routerLink="/search"
        [queryParams]="
          subject.id
            ? { categoryId: subject.id, categoryName: subject.name }
            : { query: subject.name }
        "
        ><img
          [src]="icon(subject.name)"
          width="36"
          height="36"
          alt=""
          loading="lazy"
        /><span>{{ subject.name }}</span></a
      >
    }
    @if (subjects.length > 7) {
      <button
        type="button"
        (click)="expanded = !expanded"
        [attr.aria-expanded]="expanded"
      >
        <img
          src="/assets/images/subjects/subjects.svg"
          width="36"
          height="36"
          alt=""
        /><span>{{ expanded ? 'Fewer subjects' : 'More subjects' }}</span>
      </button>
    }
  </div>
</section>
